import { ContentButton as Button } from '../content/button';
import { ContentIntro as Intro } from '../content/intro';

/**
 * Model definition for H
 */

export interface FormsHomeConstructionLoanCalculator {
  __component: 'forms.home-construction-loan-calculator';
  id: string;
  intro?: Intro;
  cta?: Button;
  loan?: number;
  downPayment?: number;
  fixedInterestPeriod?: string;
  repaymentRate?: number;
}

export function isFormsHomeConstructionLoanCalculator(obj: {
  __component?: string;
}): obj is FormsHomeConstructionLoanCalculator {
  return obj.__component === 'forms.home-construction-loan-calculator';
}
